import { ButtonTransparent } from '@components/common/Button/index.js';
import { Box } from '@styles/flexBox';
import styled, { css } from 'styled-components';

export const ShopItemGrid = styled(Box)`
  margin-right: 10px;
  margin-bottom: 20px;

  &:nth-child(3n + 3) {
    margin-right: 0;
  }

  &:nth-child(2) {
    margin-right: 10px;
  }

  ${(props) =>
    props.galleryItem &&
    css`
      margin-bottom: 0;
    `}

  ${(props) =>
    props.isShop &&
    css`
      width: 31.5%;
    `}
`;

export const OrderPriceBox = styled(Box)`
  display: flex;
  justify-content: space-between;

  @media (max-width: 568px) {
    flex-direction: column;
  }

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const Text = styled(Box)`
  margin: 5px 0;
  color: var(--secondary-gray);
  font-size: 13px;

  ${({ color }) =>
    color &&
    css`
      color: ${color};
      cursor: pointer;
      width: fit-content;
      padding: 0 16px 0 0;
    `}
`;

export const OrderPriceItem = styled(Box)`
  position: relative;

  @media (max-width: 568px) {
    width: 100%;
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${(props) =>
    props.instantRedirect &&
    css`
      width: 50%;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};

      @media (max-width: 568px) {
        width: 100%;
      }
    `}

  ${(props) =>
    props.tagPrice &&
    css`
      flex-grow: 1;
      margin-right: 15px;
    `}

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};
    `}

  ${(props) =>
    props.isCurrency &&
    css`
      &:after {
        content: '${props.isCurrency}';
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 2px;
        right: 2px;
        width: 50px;
        height: 38px;
        background: var(--secondary-background);
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    `}

  ${(props) =>
    props.isMinutes &&
    css`
      &:after {
        width: 80px;
      }
    `}
`;

export const OrderCurrencyBox = styled(Box)`
  ${(props) =>
    props.isCurrency &&
    css`
      width: 95%;

      &:after {
        content: '${props.isCurrency}';
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        bottom: 2px;
        right: 6%;
        width: 50px;
        height: 38px;
        background: var(--secondary-background);
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    `}

  ${(props) =>
    props.isCurrencyRight &&
    css`
      width: 100%;

      &:after {
        right: 1px;
      }
    `}


  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const OrderCheckbox = styled(Box)`
  display: flex;
  justify-content: space-between;
  ${({ margin }) =>
    margin &&
    css`
      margin: ${margin};
    `}
`;

export const OrderCheckboxItem = styled(Box)`
  width: 47%;
  ${({ gap }) =>
    gap &&
    css`
      display: flex;
      flex-direction: column;
      gap: ${gap};
    `}
`;

export const PostPriceBox = styled(Box)`
  display: flex;
  align-items: center;
  height: 16px;
`;

export const PostPrice = styled(Box)`
  min-width: 60px;
  padding: 5px 10px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  background: rgb(87 209 62);
  border-radius: 30px;

  ${(props) =>
    !props.isZero &&
    css`
      display: none;
    `}
`;

export const ListTag = styled(Box)`
  ${(props) =>
    props.scroll &&
    css`
      max-height: 245px;
      overflow-x: auto;
    `}

  ${(props) =>
    props.tagsTikTok &&
    css`
      max-height: 518px;
      overflow-x: auto;
    `}
`;

export const TagItem = styled(Box)`
  position: relative;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid #e9e9e9;

  ${ButtonTransparent} {
    display: none;
    cursor: pointer;
  }

  &:hover ${ButtonTransparent} {
    display: block;
  }

  ${(props) =>
    props.selected &&
    css`
      border-bottom: 2px solid green;
    `}

  ${(props) =>
    props.notActive &&
    css`
      cursor: default;
    `}
`;

export const TagImageBox = styled(Box)`
  width: 55px;
  height: 55px;
  margin-bottom: 15px;
`;

export const TagImage = styled.img`
  width: 55px;
  height: 55px;
  object-fit: cover;
  transition: all 0.3s;
`;

export const TagInfo = styled(Box)`
  margin-left: 10px;
  margin-bottom: 12px;
`;

export const TagDescription = styled(Box)`
  font-size: 15px;
  max-width: 190px;
  max-height: 38px;
  margin-bottom: 5px;
  word-break: break-word;
  overflow: hidden;

  ${(props) =>
    props.height &&
    css`
      height: ${props.height};
    `}
`;

export const TagPriceBox = styled(Box)`
  display: flex;
  font-size: 16px;
`;

export const TagPrice = styled(Box)`
  margin-right: 15px;
  //color: #0099FF;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.33px;
  color: var(--main-black);
  line-height: normal;

  ${(props) =>
    props.mediaProduct &&
    css`
      font-size: 16px;
    `}
`;

export const TagOldPrice = styled(Box)`
  //color: var(--secondary-gray);
  position: relative;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.33px;
  color: var(--main-black);
  line-height: normal;

  &:before {
    content: '';
    position: absolute;
    top: 50%;
    left: -2px;

    width: 100%;
    height: 2px;
    margin-top: -2px;
    background: #999;
  }
`;

export const ShopListView = styled(Box)`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 0;
  padding: 3px;
  background: var(--surface-elevated);
  border-radius: 10px;
`;

export const ShopListViewItem = styled(Box)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 28px;
  border-radius: 7px;
  background: transparent;
  cursor: pointer;
  transition:
    background 0.15s ease,
    box-shadow 0.15s ease;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }

  ${(props) =>
    props.isActive &&
    css`
      background: var(--main-background);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

      &:hover {
        background: var(--main-background);
      }
    `}
`;

export const ShopProductsBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ShopProductsImageBox = styled(Box)``;

export const ShopProductsImage = styled.img`
  width: 275px;
  height: auto;
`;

export const PaymentSettingBox = styled(Box)`
  display: none;
  margin-top: 30px;

  ${(props) =>
    props.isShowing &&
    css`
      display: block;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const PaymentSettingText = styled(Box)`
  margin: 15px 0;
  font-size: 14px;
  color: var(--secondary-gray);
`;

export const ButtonWrapper = styled(Box)`
  ${(props) =>
    props.stripeConnect &&
    css`
      display: flex;
    `}
`;

export const PaymentSettingTitleBox = styled(Box)`
  display: flex;
  align-items: center;
`;

export const PaymentSettingIcon = styled.img`
  width: 24px;
  height: auto;
`;

export const DonationWrapper = styled(Box)``;

export const DonationBox = styled(Box)`
  display: flex;
`;

export const DonationAmountsBox = styled(Box)`
  margin-bottom: 50px;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const DonationEmojiBox = styled(Box)`
  width: 54px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

export const DonationEmoji = styled(Box)`
  margin-left: 10px;
  font-size: 32px;
  cursor: pointer;

  span {
    position: relative;
    top: 7px;
    width: 32px;
    height: 22px;
  }
`;

export const DonationInputBox = styled(Box)`
  max-width: 150px;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
`;

export const DonationList = styled(Box)`
  display: flex;
  margin-left: 15px;
  margin-top: 25px;

  @media (max-width: 568px) {
    margin-left: 0;
  }
`;

export const DonationItem = styled(Box)`
  padding: 5px 10px;
  margin-right: 8px;
  display: flex;
  font-size: 14px;
  cursor: pointer;
  background-color: var(--surface-elevated);
  border-radius: 20px;

  align-items: center;
  gap: 4px;
`;

export const DonationItemEmoji = styled(Box)`
  display: flex;
  align-items: center;

  span {
    margin-right: 3px;
    width: 16px;
    height: 12px;
  }
`;

export const DonationItemTitle = styled(Box)``;

export const ProductsList = styled(Box)`
  margin-top: 15px;
  overflow: auto;
  max-height: ${(props) => (props.maxHeight ? `${props.maxHeight}px` : '300px')};

  ${(props) =>
    props.mediaProduct &&
    css`
      margin-top: 4px;
    `}

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const ProductsItem = styled(Box)`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
  padding-right: 10px;

  ${(props) =>
    props.active &&
    css`
      background: rgb(248, 242, 231);
      border-radius: 3px;
    `}
`;

export const ProductsImage = styled.img`
  width: 48px;
  height: 48px;
  border: 1px solid var(--border-color);
  border-radius: 3px;

  ${(props) =>
    props.mediaProduct &&
    css`
      width: 78px;
      height: 78px;
    `}
`;

export const ProductsTitle = styled(Box)`
  margin-left: 15px;
  font-size: 12px;
  color: rgb(0, 153, 255);

  ${(props) =>
    props.mediaProduct &&
    css`
      max-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0 0 3px 0;

      font-size: 15px;
      font-weight: bold;
      color: var(--main-black);
    `}
`;

export const ProductsPrice = styled(Box)`
  margin-left: auto;
  font-size: 18px;
`;

export const ProductsButton = styled(Box)`
  cursor: pointer;
  color: rgb(20, 124, 255);
`;

export const ShopItemsList = styled(Box)`
  min-height: 500px;

  ${(props) =>
    props.minHeight &&
    css`
      min-height: ${props.minHeight};
    `}
`;
